import { createContext, ReactNode, useState, useCallback, type Dispatch, type SetStateAction } from 'react'
import { BirthDateInputDialog } from '../components/BirthDateInputDialog'

type BirthDateDialogContextType = {
  setOpen: Dispatch<SetStateAction<boolean>>
}

export const BirthDateDialogContext = createContext<BirthDateDialogContextType>(undefined as never)

type Props = {
  children: ReactNode
}

export const BirthDateDialogProvider: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = useState(false)

  const handleClose = useCallback(()=> {
    setOpen(false)
  }, [])

  return (
    <BirthDateDialogContext value={{ setOpen }}>
      {children}
      <BirthDateInputDialog
        open={open}
        onClose={handleClose}
      />
    </BirthDateDialogContext>
  )
}